<template>
  <div id="app">
    <Nav />
    <Hero />
    <About />
    <Why />
    <How />
    <Download />
    <Faq />
    <Contact />
    <Footer />
  </div>
</template>

<script>
import Nav from './components/Nav.vue'
import Hero from './components/Hero.vue'
import About from './components/About.vue'
import Why from './components/Why.vue'
import How from './components/How.vue'
import Download from './components/Download.vue'
import Faq from './components/Faq.vue'
import Contact from './components/Contact.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'App',
  components: {
    Nav,
    Hero,
    About,
    Why,
    How,
    Download,
    Faq,
    Contact,
    Footer
  }
}
</script>

<style lang="scss">
#app {
  font-size: 18px;
  background: #F1F6F9;
}
::-webkit-scrollbar{
  width: 8px;
  background: #c4c4c4;
  border-radius: 32px;
}
::-webkit-scrollbar-thumb{
  background: #A13216;
  border-radius: 32px;
}
</style>
